import * as React from 'react';
import b from 'b_';
import { area as d3Area } from 'd3-shape';
import { ValueMappers } from '../../types';

interface Props {
  scales: ValueMappers;
  x: number;
  y: number;
  label: string | React.ReactElement<any>;
  pathname?: string;
}

const area = d3Area<number>();

class Bar extends React.Component<Props> {
  render() {
    const { scales, x, y, label, pathname } = this.props;

    area
      .x((shift, i) => +scales.x(x + shift))
      .y0(scales.y(0, 0))
      .y1(scales.y(y, 0));

    const bar = [-0.5, 0.48];
    return (
      <g>
        <path fill="rgba(255, 255, 255, 0.2)" d={area(bar) || undefined} />
        <path
          //https://stackoverflow.com/questions/20330149/svg-filter-only-working-when-added-in-style-attribute-firefox/20330581#20330581
          filter={`url(${pathname || ''}#inner-shadow)`}
          d={area(bar) || undefined}
        />
        <path className={b('bar-chart', 'bar')} d={area(bar) || undefined} />
        <text
          transform={`translate(${scales.x(x, 0)}, ${scales.y(0, 0)})`}
          className={b('bar-chart', 'bar-label')}
          y="-0.35em"
        >
          {label}
        </text>
      </g>
    );
  }
}

export default Bar;
